import React from 'react';
import classnames from 'classnames';

import { BaseTextInputProps } from '../BaseTextInput';
import styles from './styles.module.scss';

interface Props {
    children: any;
    className?: string;
    colorTheme: BaseTextInputProps['colorTheme'];
    error: BaseTextInputProps['error'];
    isDisabled: BaseTextInputProps['isDisabled'];
}

const BaseTextInputContainer = (props: Props) => {
    const className = classnames('text-input-container', styles.baseTextInputContainer, styles[props.colorTheme], props.className, {
        [styles.error]: !!props.error,
        [styles.disabled]: !!props.isDisabled,
    });

    return <div className={className}>{props.children}</div>;
};

BaseTextInputContainer.defaultProps = {
    className: '',
};

export default BaseTextInputContainer;
